export const sanitizeRichText = (richText: string): string => {
  return richText?.replace(/<p\b[^>]*>\s*(?:&nbsp;|<br\s*\/?>)*\s*<\/p>/gi, "");
};

export const addTitleToInlineSvg = (svgData: string, title: string): string => {
  if (svgData && !svgData.includes("<title>")) {
    svgData = svgData?.replace(">", `><title>${title}</title>`);
  }
  return svgData;
};
/**
 * Ensures consistent URL format (leading slash, no trailing slash) for reliable Map lookups
 * and URL comparisons across the application
 */
export const normalizeUrl = (value: string): string => {
  if (!value) return "/";
  let pathValue = value.startsWith("/") ? value : `/${value}`;
  if (pathValue.length > 1 && pathValue.endsWith("/")) {
    pathValue = pathValue.slice(0, -1);
  }
  return pathValue;
};
